import { useEffect } from "react";
import { motion } from "framer-motion";
import confetti from "canvas-confetti";

const COLORS = ["#FFC21A", "#FFE27A", "#B6FF3D", "#3DF5FF", "#F4F1EA"];

const burst = (rare) => {
  const base = { colors: COLORS, zIndex: 80, disableForReducedMotion: true };
  confetti({ ...base, particleCount: rare ? 160 : 90, spread: rare ? 110 : 75, startVelocity: rare ? 55 : 42, origin: { y: 0.45 } });
  if (!rare) return [];
  return [300, 700, 1200].map((d, i) =>
    setTimeout(() => {
      confetti({ ...base, particleCount: 70, angle: 60, spread: 60, origin: { x: 0, y: 0.7 } });
      confetti({ ...base, particleCount: 70, angle: 120, spread: 60, origin: { x: 1, y: 0.7 } });
      if (i === 2) confetti({ ...base, particleCount: 50, spread: 360, startVelocity: 25, shapes: ["star"], origin: { y: 0.4 } });
    }, d)
  );
};

export const WinEffects = ({ active, rare }) => {
  useEffect(() => {
    if (!active) return undefined;
    const timers = burst(rare);
    return () => {
      timers.forEach(clearTimeout);
    };
  }, [active, rare]);
  if (!active) return null;
  return (
    <div className="pointer-events-none absolute inset-0 flex items-center justify-center" data-testid={rare ? "gacha-effect-rare" : "gacha-effect-win"}>
      <motion.div
        className={`light-rays absolute rounded-full ${rare ? "h-[900px] w-[900px] rays-rare" : "h-[640px] w-[640px]"}`}
        initial={{ opacity: 0, scale: 0.4 }}
        animate={{ opacity: 1, scale: 1, rotate: 360 }}
        transition={{ opacity: { duration: 0.6 }, scale: { duration: 0.8, ease: [0.22, 1, 0.36, 1] }, rotate: { duration: rare ? 14 : 24, repeat: Infinity, ease: "linear" } }}
      />
      <motion.div
        className={`absolute rounded-full blur-3xl ${rare ? "h-80 w-80 bg-volt/60" : "h-64 w-64 bg-volt/35"}`}
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: [0, 1, 0.7], scale: [0.5, 1.3, 1] }}
        transition={{ duration: 1.2 }}
      />
      <motion.div className="absolute inset-0 bg-white" initial={{ opacity: rare ? 0.85 : 0.5 }} animate={{ opacity: 0 }} transition={{ duration: rare ? 0.9 : 0.5 }} />
    </div>
  );
};
